import React, { createContext, useContext } from 'react';
import socket from '../lib/socket';

// Create a Context object
const SocketContext = createContext(null);

// Custom hook to easily use the socket instance
export const useSocket = () => {
    return useContext(SocketContext);
};

// The context value is the socket instance itself
export const SocketProvider = ({ children }) => {
    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};